var colors = {
    aqua: '#1E7F9A',
    aqua10: '#E9F2F5',
    aqua20: '#BCD9E1',
    aqua30: '#8FBFCD',
    aqua70: '#18667B',
    aqua80: '#124C5C',
    aqua90: '#0C333E',
    blue: '#0073E6',
    blue10: '#EAF5FF',
    blue20: '#C0DFFE',
    blue30: '#96CAFE',
    blue70: '#2477CA',
    blue80: '#1B5998',
    blue90: '#123C65',
    bluev2: '#1769FF',
    gray: '#676B6C',
    gray10: '#F0F0F1',
    gray20: '#D2D3D3',
    gray30: '#B3B5B6',
    gray70: '#525656',
    gray80: '#3E4042',
    gray90: '#0A0A0B',
    green: '#008A28',
    green10: '#E6F4EA',
    green20: '#B3DCBF',
    green30: '#80C594',
    green70: '#006E20',
    green80: '#005318',
    green90: '#003710',
    hibiscus: '#E80134',
    hibiscus10: '#FDE8EB',
    hibiscus20: '#F8BBC3',
    hibiscus30: '#F38E9B',
    hibiscus70: '#B9162B',
    hibiscus80: '#8B1120',
    hibiscus90: '#5C0B16',
    indigo: '#0151D1',
    indigo10: '#E6EEFA',
    indigo20: '#B3CBF1',
    indigo30: '#80A8E8',
    indigo70: '#0141A7',
    indigo80: '#01317D',
    indigo90: '#002054',
    orange: '#FF7F00',
    orange10: '#FFF2E6',
    orange20: '#FFD9B3',
    orange30: '#FFBF80',
    orange70: '#CC6600',
    orange80: '#994C00',
    orange90: '#4A2600',
    plum: '#9C007E',
    plum10: '#F9E6F5',
    plum20: '#EDB3E2',
    plum30: '#E180CF',
    plum70: '#75005F',
    plum80: '#4E003F',
    plum90: '#2F0026',
    violet: '#785BF2',
    violet0: '#F2EFFE',
    violet20: '#D7CEFB',
    violet30: '#BCADF9',
    violet70: '#6049C2',
    violet80: '#483791',
    violet90: '#302461',
    yellow: '#EAD325',
    yellow10: '#FDFBE9',
    yellow20: '#F9F2BE',
    yellow30: '#F5E992',
    yellow70: '#BBA91E',
    yellow80: '#8C7F16',
    yellow90: '#5E540F',
    /**nexus v3 colors */
    // Top hierarchy. Invites the user to pay attention to scpecific areas. Used
    // for interactive or selected elements.
    primary10: '#e8f0ff',
    primary20: '#b5cffe',
    primary30: '#7dabff',
    primary50: '#1769ff',
    primary70: '#1254cc',
    primary80: '#0e3f99',
    primary90: '#092a66',
    // For elements like backgrounds, texts, and general shapes such as dividers.
    base10: '#f7f7fa',
    base20: '#e5e7ec',
    base30: '#bbc0ce',
    base50: '#77819c',
    base70: '#646e8a',
    base80: '#47516e',
    base90: '#353f5e',
    // for use in gradients, 30 percent lighter than $base20.
    highlightBase20: '#f7f8f9',
    white: '#ffffff',
    black: '#08031d',
    // Medium level of positive attention. Can be use for confirmations, approvals,
    // deep interaction.
    informative10: '#e2def7',
    informative20: '#c6beef',
    informative30: '#9b8de2',
    informative50: '#705cd6',
    informative70: '#4f37c9',
    informative80: '#402bab',
    informative90: '#321f94',
    // Highest level of positive attention. Positive money figures.
    success10: '#cceedc',
    success20: '#99ddb9',
    success30: '#4dc484',
    success50: '#00ab4f',
    success70: '#00893f',
    success80: '#00672f',
    success90: '#015428',
    // Medium level of urgency.
    warning10: '#fcf1d9',
    warning20: '#ffe5b4',
    warning30: '#ffd27b',
    warning50: '#ffc043',
    warning70: '#ffb234',
    warning80: '#cb7302',
    warning90: '#c7732c',
    // Use for error states, negative and destructive actions with a high level of
    // urgency.
    danger10: '#f8dddd',
    danger20: '#fcbcbb',
    danger30: '#f97877',
    danger50: '#da0b09',
    danger70: '#b92624',
    danger80: '#a41313',
    danger90: '#8c0000',
    // Used for loyalty assets such as rewards and spots.
    loyalty10: '#cc9a36',
    loyalty20: '#cc9a36',
    loyalty30: '#dfc878',
    loyalty50: '#cc9a36',
    loyalty70: '#8c6c3d',
    loyalty80: '#9d7628',
    loyalty90: '#9d7628', // non exists, using loyalty80
};

export { colors as default };
